import gsap from 'gsap';

import { app } from '../../utils/store';

class Clients {
  constructor() {
    this.clients = {
      el: document.querySelector('.s-clients'),
      img: document.querySelectorAll('.s-clients img'),
    };

    this.y = {
      current: 0,
    };

    this.window = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  init() {
    this.set();
    this.add();
  }

  set = () => {
    gsap.set(this.clients.img, {
      opacity: 0,
      y: this.window.width * 0.1,
    });
  }

  add() {
    gsap.ticker.add(this.inview);
  }

  destroy() {
    gsap.ticker.remove(this.inview);
  }

  inview = () => {
    this.y.current = Math.abs(app.scroll.data.last);

    const i = this.clients.el;
    const b = i.getBoundingClientRect();

    if (b.top < this.window.height) {
      gsap.to(this.clients.img, {
        y: 0,
        opacity: 1,
        duration: 3,
        stagger: 0.09,
        ease: 'expo.out',
        clearProps: 'all',
      });

      this.destroy();
    }
  }
}

export default Clients;
